import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils/api'

import { GET_GUESTS_BASE_QUERY_KEY } from './get-guests'

type CheckInGuestRequest = {
  clientId: number
  guestId: number
}

const checkInGuest = async ({ clientId, guestId }: CheckInGuestRequest): Promise<void> => {
  await authAPI.put(`/client/${clientId}/guest/${guestId}/checkIn`)
}

export const useCheckInGuest = () => {
  return useMutation({
    mutationFn: checkInGuest,
    onSuccess: async () => {
      await resetQueries([GET_GUESTS_BASE_QUERY_KEY])
    },
  })
}
